import { render } from "./lrbYTable2.vue?vue&type=template&id=4b2ad562&scoped=true"
import script from "./lrbYTable2.vue?vue&type=script&lang=js"
export * from "./lrbYTable2.vue?vue&type=script&lang=js"

import "./lrbYTable2.vue?vue&type=style&index=0&id=4b2ad562&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2ad562"]])

export default __exports__